<template>
  <div>
    <div class="navTitle">
      <div class="nav_warp">
        <div style="padding: 0 20px 0 0px; width: 100px">{{ dataObjs.lishishuju }}</div>
        <div class="times">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            :range-separator="$t('reach')"
            format="yyyy/MM/dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="mytimgEnd"
          ></el-date-picker>

          <!-- <div style="width:50px;height:0" class="bten">
                    <el-button
                      type="primary"
                      @click="confingClick"
                      style="padding:8px 6px !important"
                    >{{dataObjs.queding}}</el-button>
          </div>-->

          <div class="dayTime">
            <el-radio-group v-model="tabPosition" @change="dayTime">
              <el-radio-button label="1hour">{{ dataObjs.xiaoshi1 }}</el-radio-button>
              <el-radio-button label="2hour">{{ dataObjs.xiaoshi2 }}</el-radio-button>
              <el-radio-button label="1day">{{ dataObjs.tian1 }}</el-radio-button>
              <el-radio-button label="1week">{{ dataObjs.zhou1 }}</el-radio-button>
              <el-radio-button label="1month">{{ dataObjs.yue1 }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div id="myChart_lin" :style="{ width: '100%', height: '600px' }"></div>
    <div class="imgtype" v-if="flyChend == false">
      {{ dataObjs.gaishijianduanzanwushuju }}
    </div>
    <div class="zhe_boots">
      <el-radio-group v-model="channelidType" @change="channelidTypeL">
        <el-radio-button
          :label="'channel' + item.channelid"
          v-for="item in channelid"
          :key="item.channelid"
          >{{
            item.channelname == ""
              ? lang_file == "zh-cn"
                ? item.unittype
                : item.unittype_en
              : item.channelname
          }}</el-radio-button
        >
      </el-radio-group>
    </div>
    <div style="display: none">{{ hadnVluaeTime }}</div>
  </div>
</template>

<script>
import { lang_fend } from "@/network/index";
export default {
  props: {
    dataX: {
      type: Array,
      default: [],
    },
    dateset: {
      type: String,
      default: "",
    },
    value1: {
      type: Array,
      default: [],
    },
    collecttime: {
      type: Array,
      default: [],
    },
    channelid: {
      type: Array,
      default: [],
    },
    flyChend: {
      type: Boolean,
      default: true,
    },
    titleObj: {
      type: Object,
      default: {},
    },
    teab: {
      type: String,
      default: "",
    },
    dataMix: {
      type: Array,
      default: [],
    },
    lowerlimit: {
      type: Array,
      default: [],
    },
    lowrlimt: {
      type: Array,
      default: [],
    },
    titlenew: {
      type: Object,
      default: {},
    },
  },
  watch: {
    dataX: {
      handler(val) {
        this.drawLine(val, this.collecttime);
      },
    },
    teab: {
      handler(val) {
        // console.log(val,"----------------------");
        // this.channelidType = val
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      pickerOptions: {},
      objUnit: {},
      tabPosition: "",
      // value1:'',
      dataXlist: this.dataX,
      channelidType: this.teab,
      lang_file: sessionStorage.getItem("lang_file"),

      dataObjs: {},
    };
  },
  created() {},
  computed: {
    hadnVluaeTime() {
      return (this.tabPosition = this.dateset);
    },
  },
  mounted() {
    this.drawLine();
    this.lang_fend();
  },
  methods: {
    mytimgEnd(e) {
      console.log(e);
      // console.log(e)
      this.$emit("confingClick", e);
    },
    async lang_fend() {
      let page = "realtimedata_detail_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      console.log(data);

      this.dataObjs = data;
      // this.xiaoshi = data.1xiaoshi
    },
    dayTime(e) {
      this.$emit("dayTime", e);
    },
    confingClick() {
      this.$emit("confingClick", this.value1);
    },
    channelidTypeL(e) {
      let splNew = e.split("l")[1];
      this.$emit("channelidfuntEnd", e);
      /**获取标题  */
      this.channelid.forEach((item) => {
        if (item.channelid == splNew) {
          this.objUnit = {
            unit: item.unit,
            unittype: this.lang_file == "en-us" ? item.unittype_en : item.unittype,
          };
        }
      });
    },
    drawLine(data, time) {
      console.log(this.titleObj.unittype);

      let myChart = this.$echarts.init(document.getElementById("myChart_lin"));
      let unt = this.objUnit.unit == undefined ? this.titleObj.unit : this.objUnit.unit;
      // 绘制图表
      let option = {
        title: {
          left: "center",
          text:
            this.objUnit.unittype == undefined
              ? this.titleObj.unittype
              : this.objUnit.unittype,
          //   subtext: '纯属虚构'
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // left: 10,
          //   data: ['最高气温',]
        },
        dataZoom: [
          {
            // startValue: '2014-06-01'
            startValue: this.collecttime[0],
          },
          {
            type: "inside",
          },
        ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: "none"
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ["line", "bar"] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          // value || this.collecttimeList
          type: "category",
          boundaryGap: false,
          data: time || this.collecttime,
        },
        yAxis: {
          // name:'11',
          type: "value",
          axisLabel: {
            formatter: "{value}" + unt,
          },
        },
        inverse: true,
        visualMap: {
          // inverse:true,
          // dataMix
          yAxis: true,
          show: true,
          top: 10,
          right: 10,
          // orient:"vertical",
          //show:false,
          show: true,
          precision: 1,

          //   // seriesIndex:this.dataX,
          //   dimension: 0,
          pieces: this.dataMix,
          //   // pieces: [
          //   //   {
          //   //     lte: 6,
          //   //     color: "green",
          //   //   },
          //   //   {
          //   //     gt: 6,
          //   //     lte: 8,
          //   //     color: "red",
          //   //   },
          //   //   {
          //   //     gt: 8,
          //   //     lte: 14,
          //   //     color: "green",
          //   //   },
          //   //   {
          //   //     gt: 14,
          //   //     lte: 17,
          //   //     color: "red",
          //   //   },
          //   //   {
          //   //     gt: 17,
          //   //     color: "green",
          //   //   },
          //   // ],
        },

        series: [
          // {
          //   color: 'red', //折线条的颜色
          //   // name: '最高气温',
          //   smooth: true, //这个是把线变成曲线
          //   type: "line",
          //   // data: data || this.dataX,
          //   markLine: {
          //     silent: true,
          //     data: this.lowrlimt//上限
          //   },
          // },
          // {
          //   // name: '最低气温',
          //   color: 'blue', //折线条的颜色
          //   smooth: true, //这个是把线变成曲线
          //   type: "line",
          //   data: data || this.dataX,
          //   // markPoint: {
          //   //   data: [
          //   //     { type: "max", name: "最大值" },
          //   //     { type: "min", name: "最小值" },
          //   //   ],
          //   // },
          //   markLine: {
          //     silent: true,

          //     data:this.lowerlimit//下限
          // data: [
          //   // { type: "min", name: "最小值" },
          //   [
          //     {
          //       symbol: "none",
          //       x: "90%",
          //       yAxis: "max",
          //     },
          //     {
          //       symbol: "circle",
          //       label: {
          //         // position: "start",
          //         // formatter: "最大值",
          //       },
          //       // type: "max",
          //       // name: "最高点",
          //     },
          //   ],
          // ],
          // },
          // },
          {
            // name: '最低气温',
            color: "blue", //折线条的颜色
            smooth: true, //这个是把线变成曲线
            type: "line",
            data: data || this.dataX,
            markPoint: {
              data: [
                {
                  type: "max",
                  name: "最大值",
                  label: {
                    formatter: function (e) {
                      return "Max:" + e.data.value + unt;
                    },
                  },
                  itemStyle: {
                    color: "red",
                  },
                },
                {
                  type: "min",
                  name: "最小值",
                  label: {
                    formatter: function (e) {
                      return "Min:" + e.data.value + unt;
                    },
                  },
                  itemStyle: {
                    color: "blue",
                  },
                },
              ],
            },
            markLine: {
              silent: true,
              // data: this.lowerlimit, //下限
              data: this.lowrlimt, //上限
              label: {
                formatter: (e) => {
                  // console.log(e)
                  return this.titlenew.pingjunzhi + +e.data.value.toFixed(1) + unt;
                },
              },
              // data: [
              //   // { type: "min", name: "最小值" },
              //   [
              //     {
              //       symbol: "none",
              //       x: "90%",
              //       yAxis: "max",
              //     },
              //     {
              //       symbol: "circle",
              //       label: {
              //         // position: "start",
              //         // formatter: "最大值",
              //       },
              //       // type: "max",
              //       // name: "最高点",
              //     },
              //   ],
              // ],
            },
          },
        ],
      };
      myChart.setOption(option);
      // }
    },
  },
};
</script>

<style scoped>
.navTitle {
  width: 100%;
  background: #5cb6d9;
  height: 37px;
  line-height: 37px;
  color: #ffffff;
  padding: 0 20px;
  display: flex;
}
#myChart_lin {
  position: relative;
  padding: 30px 0;
}
.imgtype {
  text-align: center;
  /* line-height: 300px; */
  position: absolute;
  font-size: 22px;
  color: #969799;
  margin: 0 auto;
  /* position: fixed; */
  left: 50%;
  top: 50%;
  transform: translate(-50%);
  /* buttom:50%; */
}
.nav_warp {
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.zhe_boots {
  text-align: center;
  padding-top: 40px;
}
.dayTime {
  width: 100%;
  padding: 0 20px;
}
.times {
  width: 100%;
  display: flex;
}
</style>
